module.exports = __webpack_public_path__ + "img/dumpattenuator_parked.bc6deed5.svg";